export default class HelpLinks {
    static setup (helpLinkSelector, helpContentSelector) {
        HelpLinks.setupHideClickEvent(helpLinkSelector, helpContentSelector);
        HelpLinks.setupMainClickEvent(helpLinkSelector, helpContentSelector);
    }

    static setupHideClickEvent (helpLinkSelector, helpContentSelector) {
        $(document).on('click.helpLinkHide', (event) => {
            const target = $(event.target);

            if (target.closest(helpContentSelector).length || target.closest(helpLinkSelector).length) {
                return;
            }

            $(helpContentSelector).hide().removeClass('active');
        });
    }

    static setupMainClickEvent (helpLinkSelector, helpContentSelector) {
        $(document).on('click.helpLinkToggle', helpLinkSelector, (event) => {
            event.preventDefault();

            let helpContent = $(event.target).next(helpContentSelector);

            if (helpContent.hasClass('is-hidden')) {
                // if the current element is hidden we must be viewing Māori translated content
                // so grab the next .search-help-content element which is the Māori translation
                helpContent = helpContent.next(helpContentSelector);
            }

            const wasActive = helpContent.hasClass('active');

            $(helpContentSelector).hide().removeClass('active');

            if (!wasActive) {
                $(helpContent).addClass('active');
                $(helpContent).show();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/js/app/help-link.js